import { extendTheme } from 'native-base'

import { breakpoints } from './breakpoints'
import { colors } from './colors'
import { Button } from './components/button'
import { Checkbox } from './components/checkbox'
import { Heading } from './components/heading'
import { Input } from './components/input'
import { Switch } from './components/switch'
import { Text } from './components/text'
import { sizes } from './sizes'
import { spacing } from './space'
import { typography } from './typography'

export const theme = extendTheme({
  colors,
  components: { Button, Checkbox, Switch, Heading, Input, Text },
  config: {
    useSystemColorMode: false,
    initialColorMode: 'light'
  },
  sizes,
  space: spacing,
  breakpoints,
  ...typography
})

// Extend the internal NativeBase Theme
type CustomThemeType = typeof theme

declare module 'native-base' {
  interface ICustomTheme extends CustomThemeType {}
}
